import { createFileRoute } from '@tanstack/react-router';
import { AppShell } from '@/components/AppShell';
import { SearchView } from '@/features/search/SearchView';

export const Route = createFileRoute('/search')({
  component: () => (
    <AppShell>
      <SearchView />
    </AppShell>
  ),
});
